import { render, staticRenderFns } from "./PersonTab.vue?vue&type=template&id=00a597dc&"
import script from "./PersonTab.vue?vue&type=script&lang=js&"
export * from "./PersonTab.vue?vue&type=script&lang=js&"
import style0 from "./PersonTab.vue?vue&type=style&index=0&id=00a597dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports